import gql from 'graphql-tag';
export default gql`
  mutation getFileByUUID($uuid: String) {
    getFileByUUID(uuid: $uuid) {
      uuid
      signedUrl
    }
  }
`;
